let parentOrigin: string = null;
let hostEventConfig = {
    shouldBypassPayloadValidation: true,
    useHostEventsV2: false,
} as {
    shouldBypassPayloadValidation: boolean;
    useHostEventsV2: boolean;
};

export const setParentOrigin = (origin: string, protocol?: string) => {
    const fallback =
        window.location !== window.parent.location
            ? document.referrer
            : document.location.href;

    const fallbackProtocol = document.referrer.split('://')[0];
    let resolvedProtocol = protocol?.toLowerCase() || fallbackProtocol;

    if (!['http', 'https'].includes(resolvedProtocol)) {
        resolvedProtocol = 'https';
    }

    const sdkOrigin =
        origin && origin !== 'local-host'
            ? `${resolvedProtocol}://${origin}`
            : null;

    parentOrigin = origin === 'local-host' ? '*' : sdkOrigin || fallback || '*';
};

export const getParentOrigin = () => parentOrigin;

export const computeHash = (data: any) =>
    typeof data === 'object' ? JSON.stringify(data) : String(data);

export const setHostEventConfig = (config: any) => {
    // Merge with defaults - if value is undefined/null, use default
    hostEventConfig = {
        shouldBypassPayloadValidation:
            config.shouldBypassPayloadValidation !== undefined
                ? config.shouldBypassPayloadValidation === true
                : hostEventConfig.shouldBypassPayloadValidation,
        useHostEventsV2:
            config.useHostEventsV2 !== undefined
                ? config.useHostEventsV2 === true
                : hostEventConfig.useHostEventsV2,
    };
};

export const getHostEventConfig = () => hostEventConfig;
